import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { createProjectSteps } from '../constants/createProjectSteps';

export function useNextProjectStep() {
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId } = useParams();

  const goToNextStep = () => {
    const currentIndex = createProjectSteps.findIndex(step =>
      location.pathname.includes(step.path)
    );

    const nextStep = createProjectSteps[currentIndex + 1];

    if (nextStep) {
      if (projectId === 'new' || !projectId) {
        // New project route
        navigate(`/projects/new/${nextStep.path}`);
      } else {
        // Existing project route
        navigate(`/projects/${projectId}/${nextStep.path}`);
      }
    } else {
      console.warn("You're on the last step or the current step is not found.");
    }
  };

  return { goToNextStep };
}
